<template>
    <search-summary-layout :search-disabled="searchDisabled" :form-component="searchFormComponent">
        <template v-slot:title>
            {{ locationLabel }}
        </template>
        <template v-slot:content>
            <div>
                {{ dates }}
            </div>
            <div>
                {{ touristsTotal }}
                {{ $t('guest', touristsTotal) }}
            </div>
        </template>
    </search-summary-layout>
</template>

<script lang="ts">
    import {Component, Prop, Vue, Watch} from 'vue-facing-decorator'
    import SearchSummaryLayout from '~src/components/parts/searchSummaryLayout.src'
    import CruisesSearchForm from '~/components/cruises/search/forms/CruisesSearchForm.vue'

    //TODO Hide if empty searchRequest
    @Component({
        components: {
            SearchSummaryLayout,
            CruisesSearchForm,
        },
    })
    export class CruisesSearchSummary extends Vue {
        @Prop({default: false, type: Boolean}) searchDisabled
        @Prop({required: true}) searchRequest
        @Prop({required: true}) dates

        searchForm = false

        @Watch('isSearchActive')
        onLoadingChange(searchActive) {
            if (searchActive) {
                this.searchForm = false
            }
        }

        get searchFormComponent() {
            return resolveComponent('CruisesSearchForm')
        }

        get isSearchActive() {
            return cruisesRuntimeStore.searchActive
        }

        get locationLabel() {
            const departure = cruisesRuntimeStore.departureCity?.name
                ? `${cruisesRuntimeStore.departureCity?.name}, ${cruisesRuntimeStore.departureCity?.countryName}`
                : cruisesRuntimeStore.departureCountry?.name
            const destination = cruisesRuntimeStore.destinationCity?.name
                ? `${cruisesRuntimeStore.destinationCity.name}, ${cruisesRuntimeStore.destinationCity.countryName}`
                : cruisesRuntimeStore.destinationCountry?.name

            return departure ? `${departure} - ${destination}` : ` ${destination}`
        }

        get touristsTotal() {
            return this.searchRequest.adults + this.searchRequest.childrenAges.length
        }

        formattedDate(date) {
            return date ? this.$filters.dateFormat(this.$dateFns.parseISO(date)) : ''
        }

        checkDisabled(on) {
            if (this.searchDisabled) return
            return on
        }
    }

    export default CruisesSearchSummary
</script>
